export default __webpack_public_path__ + "static/zohoRec-7939d78f0a0ad830f7f1b7d1d174145b.png";